module.exports = __webpack_public_path__ + "img/comments_icon.b253dde1.svg";